import { Component } from '@angular/core';

@Component({
  selector: 'app-modcrypto26',
  templateUrl: './modcrypto26.component.html',
  styleUrl: './modcrypto26.component.css'
})
export class Modcrypto26Component {

}
